import {
  FETCH_ORG_CONFIG,
} from '../actions/types';

const DEFAULT_STATE = {
  loading: true,
  saving: false,
  error: null,
  data: null,
}

export default function(state = DEFAULT_STATE, action){
  switch(action.type){
    case FETCH_ORG_CONFIG:
      return {
        ...state,
        saving: false,
        loading: false,
        data: action.payload,
        orgId: (action.payload || {})._id
      }
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/orgConfigReducer.js